const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'development';
const getInitialApiUrl = (): string => {
  if (typeof window !== 'undefined') {
    const custom = localStorage.getItem('API_URL_ADMIN');
    if (custom) return custom;
  }
  return import.meta.env.VITE_API_URL_ADMIN || 'http://localhost:11000';
};
const API_URL_ADMIN = getInitialApiUrl();
const ADMIN_URL = import.meta.env.VITE_ADMIN_URL || 'http://localhost:11001';
const MAPTILER_API_KEY = 'zpcBwomuvc9uX1WpqIPt';

const PORTAL_PROJECT_ID = 1;
const BLOG_PROJECT_ID = 28;

export { API_URL_ADMIN, ADMIN_URL, PORTAL_PROJECT_ID, BLOG_PROJECT_ID, MAPTILER_API_KEY, ENVIRONMENT };
